/**
 * 剪贴板工具函数
 *
 * 使用 Clipboard API (所有现代浏览器均支持)
 */

/**
 * 复制文本到剪贴板
 *
 * @param text - 要复制的文本
 * @returns 是否复制成功
 *
 * @example
 * ```ts
 * const success = await copyToClipboard('Hello World');
 * if (success) {
 *   message.success('已复制到剪贴板');
 * }
 * ```
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    // Clipboard API 不可用或权限被拒绝
    return false;
  }
}
